/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Loader from "../../common/Lottifiers/Loader/Loader";

interface Props {
  isLoading?: any;
}
const SSOPresenter = ({ isLoading }: Props) => {
  return isLoading && <Loader height={300} width={500} />;
};

export default SSOPresenter;
